import type { SerializedError } from "@reduxjs/toolkit";

import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import initialConfig from "../initialConfig";

const initialState = {
  afterOrderData: {},
  afterOrderLoading: false,
  afterOrderError: null as SerializedError | null,
};

interface IAfterOrderInput {
  orderId: string;
  accessToken: string;
}

export const afterOrderFunc = createAsyncThunk("afterOrder/afterOrderFunc", async (values: IAfterOrderInput) => {


  const data1 = JSON.stringify({
    query: `mutation User_updateOrderAfterIyzicoCheckoutFormPayment($orderId: ID!) {
      user_updateOrderAfterIyzicoCheckoutFormPayment(orderId: $orderId) {
        order {
          _id
        }
      }
    }`,
    variables: {
      "orderId": values.orderId,
    }
  });

  const config = initialConfig('https://api.hophop.com.tr/payment/graphql', data1, values.accessToken);

  const response = axios(config).then((res) => {
    const data = res.data;
    return data;
  }).catch((err) => err);

  const data = await response;
  return data;
});


const afterOrder = createSlice({
  name: "afterOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(afterOrderFunc.pending, (state) => {
      state.afterOrderLoading = true;
    });
    builder.addCase(afterOrderFunc.fulfilled, (state, action) => {
      state.afterOrderLoading = false;
      state.afterOrderData = action.payload?.data?.user_updateOrderAfterIyzicoCheckoutFormPayment;
      state.afterOrderError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(afterOrderFunc.rejected, (state, action) => {
      state.afterOrderLoading = false;
      state.afterOrderError = action.error;
    });
  }
});

export default afterOrder.reducer;